



















import Vue from "vue"
import SimpleModal from "~/components/guideline/modal/SimpleModal.vue"
import ConversionButton from "~/components/guideline/button/ConversionButton.vue"

export default Vue.extend({
  components: {
    SimpleModal,
    ConversionButton,
  },
  props: {
    isShown: {
      type: Boolean,
      required: true,
    },
  },
  methods: {
    navigateToContactForm() {
      window.open(
        "https://crowdlinks.jp/client/form/contact/?from=scout_modal",
        "_blank"
      )
    },
    handleClickOverlay() {
      this.$emit("click-overlay")
    },
  },
})
